export * as inputs from './inputs'
export * as mutations from './mutations'
export * as queries from './queries'
